import { useEffect, useMemo, useState } from "react";
import {
  ACTION_LABEL,
  icons,
  LABELS,
  SEARCH_DATA,
} from "../../../shared/constants";
import Navbar from "../../Navbar/NavbarComponent";
import Table from "../../../shared/components/Table";
import { useFeedbackListQuery } from "../../../Features/feedback/feedback-slice";
import { secondDateConvert } from "../../../shared/helperFunc/dateConvert";
import { SortingState } from "@tanstack/react-table";

const FeedbackReportList = (props: any) => {
  const {} = props;

  const [sort, setSort]: any = useState(SEARCH_DATA);
  const [reportFollowUpList, setReportFollowUpList] = useState([]);
  const [count, setCount] = useState();
  const [columnSortState, setColumnSortState] = useState<SortingState>([]);

  useEffect(() => {
    if (columnSortState.length > 0) {
      setSort({
        ...sort,
        sortBy: columnSortState[0].id,
        sort: columnSortState[0].desc ? "desc" : "asc",
      });
    } else {
      setSort({
        ...sort,
        sortBy: "createdAt",
        sort: "desc",
      });
    }
  }, [columnSortState]);

  const {
    data,
    isSuccess,
    isFetching: reportListFetching,
  } = useFeedbackListQuery(
    { ...sort },
    {
      refetchOnFocus: true,
      refetchOnMountOrArgChange: true,
    }
  );

  useEffect(() => {
    if (isSuccess) {
      setReportFollowUpList(data.list);
      setCount(data.count);
    }
  }, [data, isSuccess]);

  const columns = useMemo(
    () => [
      {
        header: LABELS.ORDER_NO_TEXT,
        accessorKey: ACTION_LABEL.DOCUMENT_NO,
        isShow: true,
        enableSorting: false,
      },
      {
        header: LABELS.MOBILE_NO_TEXT,
        accessorKey: ACTION_LABEL.MOBILE_NO,
        isShow: true,
        enableSorting: false,
      },
      {
        header: LABELS.RATE_TEXT,
        // header: () => (
        //   <div>
        //     {LABELS.RATE_TEXT} <i className={`f6 ${icons.ICON_CHEVRON_UP}`} />
        //   </div>
        // ),
        accessorKey: ACTION_LABEL.RATE,
        isShow: true,
        enableSorting: true,
      },
      {
        header: LABELS.REMARKS_TEXT,
        accessorKey: ACTION_LABEL.REMARKS,
        isShow: true,
        enableSorting: false,
      },
      {
        header: LABELS.ORDER_DATE_TEXT,
        accessorKey: ACTION_LABEL.CREATED_AT,
        cell: ({ row }: any) =>
          secondDateConvert(row.original[ACTION_LABEL.CREATED_AT]),
        isShow: true,
        enableSorting: false,
      },
    ],
    []
  );

  return (
    <>
      <div className="full-height">
        <Navbar title={LABELS.CUSTOMER_FEEDBACK_TEXT} />
        <main className="main-content">
          <div className="pt-3">
            <div className="container-fluid">
              <div className="card custom-card card-full mt-3">
                <div className="card-body p-0">
                  <Table
                    data={reportFollowUpList}
                    columns={columns}
                    sort={sort}
                    setSort={setSort}
                    columnSortState={columnSortState}
                    setColumnSortState={setColumnSortState}
                    coloumnDrop={false}
                    count={count}
                    isFetching={reportListFetching}
                  />
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default FeedbackReportList;
